function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire984b"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire984b"] = parcelRequire;
}
parcelRequire.register("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = {};
function $ef7689007096c8a0$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$ef7689007096c8a0$var$mapping[keys[i]] = pairs[keys[i]];
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $ca355aacf03f4c85$exports = {};

(parcelRequire("kyEFX")).register(JSON.parse('{"9Dr7B":"events.3a8f333e.js","1wXcB":"event-Anniversary.8b56dfa8.svg","b5oVf":"event-Birthday.2e8df6c3.svg","ajWFr":"event-CoffeeChat.ce8a7398.svg","4FQwD":"event-Default.187cd965.svg","c8ZHA":"event-HappyHour.5f856e27.svg","aYTDe":"event-MagicHour.7e182902.svg","7xufe":"event-PayDay.681b83cd.svg","f0zNe":"event-TeamLunch.f7e16c72.svg","8z7zV":"map-pin.09f528f9.svg","01Vd9":"map-pin-white.6a01103e.svg","1INq0":"pattern.41e4058b.css","j6GAN":"youshouldnotbehere.f0aefe0e.js"}'));



var $hrTe4 = parcelRequire("hrTe4");

var $4zpiX = parcelRequire("4zpiX");
const $333f95d0b0b0f831$var$STORAGE_ROOT = "fnsz_app_last_";
const $333f95d0b0b0f831$var$SERVER_URL = "https://funsizeapps.b4a.app/";
const $333f95d0b0b0f831$var$PEVENTS_ENDPOINT = "getPersonalEvents";
const $333f95d0b0b0f831$var$CEVENTS_ENDPOINT = "getCompanyEvents";
const $333f95d0b0b0f831$var$HEVENTS_ENDPOINT = "getHowdyEvents";
const $333f95d0b0b0f831$var$APP_ID = "rHwkgreMFdjMqUGu9EoemDE4YMomVNLQwIX9Czr9";
const $333f95d0b0b0f831$var$JAVASCRIPT_KEY = "xdllsMsa2dAhWFuovVzyJTj7OIZmzLMeo5vsEFYv";
const $333f95d0b0b0f831$var$REST_API_KEY = "fabjEVYWZCwtBWXZ62BF3oAjU7ZzipumKecJidKJ";
$4zpiX.initialize($333f95d0b0b0f831$var$APP_ID, $333f95d0b0b0f831$var$JAVASCRIPT_KEY);
$4zpiX.serverURL = $333f95d0b0b0f831$var$SERVER_URL;
var $333f95d0b0b0f831$var$funsizer, $333f95d0b0b0f831$var$funsizerId, $333f95d0b0b0f831$var$funsierIdToken, $333f95d0b0b0f831$var$pEventsLoaded, $333f95d0b0b0f831$var$cEventsLoaded, $333f95d0b0b0f831$var$hEventsLoaded, $333f95d0b0b0f831$var$pEvents, $333f95d0b0b0f831$var$cEvents, $333f95d0b0b0f831$var$hEvents, $333f95d0b0b0f831$var$eventRules;
var $5d2059679daf8467$exports = {};

$5d2059679daf8467$exports = new URL((parcelRequire("kyEFX")).resolve("1wXcB"), import.meta.url).toString();


var $69e19d372be14bcd$exports = {};

$69e19d372be14bcd$exports = new URL((parcelRequire("kyEFX")).resolve("b5oVf"), import.meta.url).toString();


var $f7d213df40bfa55f$exports = {};

$f7d213df40bfa55f$exports = new URL((parcelRequire("kyEFX")).resolve("ajWFr"), import.meta.url).toString();


var $8492aee19ce7899b$exports = {};

$8492aee19ce7899b$exports = new URL((parcelRequire("kyEFX")).resolve("4FQwD"), import.meta.url).toString();


var $a835b0b1ae3bc81e$exports = {};

$a835b0b1ae3bc81e$exports = new URL((parcelRequire("kyEFX")).resolve("c8ZHA"), import.meta.url).toString();


var $4291dff411c1deb9$exports = {};

$4291dff411c1deb9$exports = new URL((parcelRequire("kyEFX")).resolve("aYTDe"), import.meta.url).toString();


var $69dff72237f789b3$exports = {};

$69dff72237f789b3$exports = new URL((parcelRequire("kyEFX")).resolve("7xufe"), import.meta.url).toString();


var $a96ee5286498d01f$exports = {};

$a96ee5286498d01f$exports = new URL((parcelRequire("kyEFX")).resolve("f0zNe"), import.meta.url).toString();


var $8e1ae894587bf9d1$exports = {};

$8e1ae894587bf9d1$exports = new URL((parcelRequire("kyEFX")).resolve("8z7zV"), import.meta.url).toString();


var $e62f50914b0bd9be$exports = {};

$e62f50914b0bd9be$exports = new URL((parcelRequire("kyEFX")).resolve("01Vd9"), import.meta.url).toString();


const $333f95d0b0b0f831$var$icons = [
    {
        keyword: "Anniversary",
        image: new URL($5d2059679daf8467$exports)
    },
    {
        keyword: "Birthday",
        image: new URL($69e19d372be14bcd$exports)
    },
    {
        keyword: "CoffeeChat",
        image: new URL($f7d213df40bfa55f$exports)
    },
    {
        keyword: "Default",
        image: new URL($8492aee19ce7899b$exports)
    },
    {
        keyword: "HappyHour",
        image: new URL($a835b0b1ae3bc81e$exports)
    },
    {
        keyword: "MagicHour",
        image: new URL($4291dff411c1deb9$exports)
    },
    {
        keyword: "PayDay",
        image: new URL($69dff72237f789b3$exports)
    },
    {
        keyword: "TeamLunch",
        image: new URL($a96ee5286498d01f$exports)
    },
    {
        keyword: "MapPin",
        image: new URL($8e1ae894587bf9d1$exports)
    },
    {
        keyword: "MapPinWhite",
        image: new URL($e62f50914b0bd9be$exports)
    }
];
window.addEventListener("load", ()=>{
    gsap.to(document.getElementsByClassName("loader-container")[0], {
        opacity: 1,
        duration: 0.25
    });
    gsap.to(document.getElementsByClassName("loader")[0], {
        scale: 0.5,
        duration: 1,
        ease: "bounce.out",
        repeat: -1,
        yoyo: true
    });
    document.getElementById("btn_logout").addEventListener("click", ()=>{
        $4zpiX.User.logOut().then(()=>{
            $333f95d0b0b0f831$var$initFunsizer();
        });
    });
    $333f95d0b0b0f831$var$initFunsizer();
    const hiddens = document.querySelector("nav").getElementsByClassName("hidden");
    for(var i = 0; i < hiddens.length; i++)gsap.to(hiddens[i], {
        opacity: 1,
        duration: 0.35,
        delay: 0.2 * i
    });
});
const $333f95d0b0b0f831$var$initFunsizer = ()=>{
    $333f95d0b0b0f831$var$funsizer = $4zpiX.User.current();
    if ($333f95d0b0b0f831$var$funsizer) $333f95d0b0b0f831$var$getFunsizerId().then((id)=>{
        $333f95d0b0b0f831$var$funsizerId = id;
        var obj = $333f95d0b0b0f831$var$funsizer.get("authData");
        $333f95d0b0b0f831$var$funsierIdToken = obj.google.id_token;
        if ($333f95d0b0b0f831$var$funsizer.get("accessToken")) $333f95d0b0b0f831$var$listEvents();
        else window.location = `${window.location.origin}/${window.location.pathname.includes("staging") ? "staging/" : ""}eventauth.html?redirect=${window.location.pathname}`;
    }).catch(function(e) {
        $333f95d0b0b0f831$var$handleParseError("Error getting your Funsizer info ", e);
    });
    else window.location = `${window.location.origin}/${window.location.pathname.includes("staging") ? "staging/" : ""}login.html?redirect=${window.location.pathname}`;
};
async function $333f95d0b0b0f831$var$getFunsizerId() {
    const id = localStorage.getObject("funsizer_id");
    if (id == null) {
        const query = new $4zpiX.Query($4zpiX.User);
        query.equalTo("email", $333f95d0b0b0f831$var$funsizer.get("email"));
        try {
            const user = await query.find();
            localStorage.setObject("funsizer_id", user[0].id);
            return user[0].id;
        } catch (error) {
            throw error;
        }
    }
    return id;
}
/**
 * Calendar Calls
*/ const $333f95d0b0b0f831$var$eventTimer = 300000; //every 5 minutes
setInterval(()=>{
    $333f95d0b0b0f831$var$listEvents();
}, $333f95d0b0b0f831$var$eventTimer);
const $333f95d0b0b0f831$var$shouldLoadEventsFromAPI = ()=>{
    const now = Date.now();
    const lastTime = localStorage.getObject(`${$333f95d0b0b0f831$var$STORAGE_ROOT}event_load`);
    const data = localStorage.getObject(`${$333f95d0b0b0f831$var$STORAGE_ROOT}event_data`);
    if (lastTime == null || data == null) {
        localStorage.setObject(`${$333f95d0b0b0f831$var$STORAGE_ROOT}event_load`, now);
        return true;
    }
    return now - lastTime > $333f95d0b0b0f831$var$eventTimer;
};
const $333f95d0b0b0f831$var$listEvents = ()=>{
    if (!$333f95d0b0b0f831$var$shouldLoadEventsFromAPI()) {
        $333f95d0b0b0f831$var$renderEvents();
        return;
    }
    const query = new $4zpiX.Query("Event");
    query.find().then((ers)=>{
        $333f95d0b0b0f831$var$eventRules = ers;
        $333f95d0b0b0f831$var$getPersonalEvents();
        $333f95d0b0b0f831$var$getCompanyEvents();
        $333f95d0b0b0f831$var$getHowdyEvents();
    }).catch(function(e) {
        $333f95d0b0b0f831$var$handleParseError("Error when getting events data.", e);
    });
};
const $333f95d0b0b0f831$var$getPersonalEvents = ()=>{
    $333f95d0b0b0f831$var$pEventsLoaded = false;
    var endpoint_uri = $333f95d0b0b0f831$var$SERVER_URL + $333f95d0b0b0f831$var$PEVENTS_ENDPOINT + "?user_id=" + $333f95d0b0b0f831$var$funsizerId + "&id_token=" + $333f95d0b0b0f831$var$funsierIdToken;
    // console.log('uir ' + endpoint_uri);
    const xhr = new XMLHttpRequest();
    xhr.onload = ()=>{
        if (xhr.status == 200) {
            var data = JSON.parse(xhr.responseText);
            const events = data.message;
            // console.log('[[[[personal events]]]')
            // console.log(events)
            $333f95d0b0b0f831$var$pEventsLoaded = true;
            $333f95d0b0b0f831$var$pEvents = [];
            $333f95d0b0b0f831$var$createEventObjects(events, $333f95d0b0b0f831$var$pEvents);
            $333f95d0b0b0f831$var$reconcileEvents();
        } else console.log("Ooops! " + xhr.status + ": " + xhr.responseText);
    };
    xhr.open("GET", endpoint_uri, true);
    // xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    // xhr.setRequestHeader('X-Parse-Javascript-Key', JAVASCRIPT_KEY);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("X-Parse-REST-API-Key", $333f95d0b0b0f831$var$REST_API_KEY);
    xhr.setRequestHeader("X-Parse-Application-Id", $333f95d0b0b0f831$var$APP_ID);
    xhr.withCredentials = true;
    xhr.send();
};
const $333f95d0b0b0f831$var$getCompanyEvents = ()=>{
    $333f95d0b0b0f831$var$cEventsLoaded = false;
    var endpoint_uri = $333f95d0b0b0f831$var$SERVER_URL + $333f95d0b0b0f831$var$CEVENTS_ENDPOINT + "?user_id=" + $333f95d0b0b0f831$var$funsizerId + "&id_token=" + $333f95d0b0b0f831$var$funsierIdToken;
    // console.log('uir ' + endpoint_uri);
    const xhr = new XMLHttpRequest();
    xhr.onload = ()=>{
        if (xhr.status == 200) {
            var data = JSON.parse(xhr.responseText);
            const events = data.message;
            // console.log('[[[[company events]]]')
            // console.log(events)
            $333f95d0b0b0f831$var$cEvents = [];
            $333f95d0b0b0f831$var$createEventObjects(events, $333f95d0b0b0f831$var$cEvents);
            $333f95d0b0b0f831$var$cEventsLoaded = true;
            $333f95d0b0b0f831$var$reconcileEvents();
        } else console.log("Ooops! " + xhr.status + ": " + xhr.responseText);
    };
    xhr.open("GET", endpoint_uri, true);
    // xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    // xhr.setRequestHeader('X-Parse-Javascript-Key', JAVASCRIPT_KEY);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("X-Parse-REST-API-Key", $333f95d0b0b0f831$var$REST_API_KEY);
    xhr.setRequestHeader("X-Parse-Application-Id", $333f95d0b0b0f831$var$APP_ID);
    xhr.withCredentials = true;
    xhr.send();
};
const $333f95d0b0b0f831$var$getHowdyEvents = ()=>{
    $333f95d0b0b0f831$var$cEventsLoaded = false;
    var endpoint_uri = $333f95d0b0b0f831$var$SERVER_URL + $333f95d0b0b0f831$var$HEVENTS_ENDPOINT + "?user_id=" + $333f95d0b0b0f831$var$funsizerId + "&id_token=" + $333f95d0b0b0f831$var$funsierIdToken;
    // console.log('uir ' + endpoint_uri);
    const xhr = new XMLHttpRequest();
    xhr.onload = ()=>{
        if (xhr.status == 200) {
            var data = JSON.parse(xhr.responseText);
            const events = data.message;
            // console.log('[[[[howdy events]]]')
            // console.log(events)
            $333f95d0b0b0f831$var$hEvents = [];
            $333f95d0b0b0f831$var$createEventObjects(events, $333f95d0b0b0f831$var$hEvents);
            $333f95d0b0b0f831$var$hEventsLoaded = true;
            $333f95d0b0b0f831$var$reconcileEvents();
        } else console.log("Ooops! " + xhr.status + ": " + xhr.responseText);
    };
    xhr.open("GET", endpoint_uri, true);
    // xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    // xhr.setRequestHeader('X-Parse-Javascript-Key', JAVASCRIPT_KEY);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("X-Parse-REST-API-Key", $333f95d0b0b0f831$var$REST_API_KEY);
    xhr.setRequestHeader("X-Parse-Application-Id", $333f95d0b0b0f831$var$APP_ID);
    xhr.withCredentials = true;
    xhr.send();
};
const $333f95d0b0b0f831$var$WEEK_LENGTH = 604800000;
const $333f95d0b0b0f831$var$createEventObjects = (a, dest)=>{
    //TODO: Do this correctly by adding an "exact match" option to the event object
    //KLUDGE: If Keyword begins with '*' then that means exact match. Parse those first
    var exacts = $333f95d0b0b0f831$var$eventRules.filter((rule)=>rule.get("Keyword").includes("*"));
    var softs = $333f95d0b0b0f831$var$eventRules.filter((rule)=>!rule.get("Keyword").includes("*"));
    var filtered = a.filter((item)=>{
        // console.log(item.summary)
        var matches = false;
        for(var i = 0; i < exacts.length; i++){
            const check = exacts[i].get("Keyword").replace("*", "");
            matches = item.summary == check;
            if (matches) {
                const excluded = exacts[i].get("ExcludedWords");
                if (excluded) {
                    const excl = excluded.split(",");
                    for(var j = 0; j < excl.length; j++)if (matches && item.summary.includes(excl[j])) matches = false;
                }
            }
            if (matches) {
                //TODO: This is another total kludge because I know we just have anniversaries to contend with atm...need proper categories in the DB
                item.category = exacts[i].get("Keyword").includes("HH") ? "Happy Hour" : "Anniversary";
                // item.category = exacts[i].get('Keyword');
                item.imageUrl = exacts[i].get("Image").url();
                item.countdown = exacts[i].get("Countdown");
                item.categoryIconKeyword = item.category.replace(" ", "");
                break;
            }
        }
        if (!matches) for(var i = 0; i < softs.length; i++){
            matches = item.summary.includes(softs[i].get("Keyword"));
            if (matches) {
                const excluded = softs[i].get("ExcludedWords");
                if (excluded) {
                    const excl = excluded.split(",");
                    for(var j = 0; j < excl.length; j++)if (matches && item.summary.includes(excl[j])) matches = false;
                }
            }
            if (matches) {
                item.category = softs[i].get("Keyword");
                item.imageUrl = softs[i].get("Image").url();
                item.countdown = softs[i].get("Countdown");
                item.categoryIconKeyword = item.category.replace(" ", "");
                break;
            }
        }
        return matches;
    });
    if (filtered.length == 0) return;
    const nowD = new Date();
    nowD.setDate(nowD.getDate() - (nowD.getDay() - 1)); // Setting date to last Monday
    nowD.setHours(0, 0, 0, 0); // Setting Hour to 00:00:00:00
    filtered.forEach((i)=>{
        var obj = new Object();
        obj.category = i.category;
        obj.categoryIconKeyword = i.categoryIconKeyword;
        obj.countdown = i.countdown;
        obj.imageUrl = i.imageUrl;
        obj.title = i.summary;
        obj.allDay = i.start.date != null;
        obj.location = "";
        if (i.location) {
            const locs = i.location.split(",");
            obj.location = locs[0];
        }
        var startD = new Date(i.start.dateTime);
        if (obj.allDay) {
            const tempD = new Date(i.start.date);
            startD = new Date(tempD.getFullYear(), tempD.getMonth(), tempD.getDate() + 1);
        }
        // console.log(startD)
        obj.trueDate = startD;
        const thisWeek = nowD.getTime() <= startD.getTime() && startD.getTime() < nowD.getTime() + $333f95d0b0b0f831$var$WEEK_LENGTH;
        obj.time = "";
        if (obj.allDay) {
            const tempEndD = new Date(i.end.date);
            const endD = new Date(tempEndD.getFullYear(), tempEndD.getMonth(), tempEndD.getDate());
            //if end is not start, show duration 
            var addendum = "";
            if (startD.getTime() != endD.getTime()) {
                if (thisWeek) addendum = ` - ${endD.toLocaleString("en-US", {
                    weekday: "short"
                })}, ${endD.toLocaleString("en-US", {
                    month: "short"
                })} ${endD.getDate()} ${addendum}`;
                else addendum = ` - ${endD.toLocaleString("en-US", {
                    month: "short"
                })} ${endD.getDate()} ${addendum}`;
            }
            //if this week show day and date otherwise just date
            if (thisWeek) obj.date = `${startD.toLocaleString("en-US", {
                weekday: "short"
            })}, ${startD.toLocaleString("en-US", {
                month: "short"
            })} ${startD.getDate()} ${addendum}`;
            else obj.date = `${startD.toLocaleString("en-US", {
                month: "short"
            })} ${startD.getDate()} ${addendum}`;
        } else {
            //if this week show day otherwise date 
            if (thisWeek) obj.date = `${startD.toLocaleString("en-US", {
                weekday: "short"
            })}`;
            else obj.date = `${startD.toLocaleString("en-US", {
                month: "short"
            })} ${startD.getDate()}`;
            var startH = startD.getHours();
            startH = startH > 12 ? startH - 12 : startH;
            var startM = startD.getMinutes();
            startM = startM < 10 ? ":0" + startM : ":" + startM;
            startM = startD.getHours() >= 12 ? "pm" : "am";
            const endD = new Date(i.end.dateTime);
            var endH = endD.getHours();
            endH = endH > 12 ? endH - 12 : endH;
            var endM = endD.getMinutes();
            endM = endM < 10 ? ":0" + endM : ":" + endM;
            endM = endD.getHours() >= 12 ? "pm" : "am";
            obj.time = `, ${startH}${startM}-${endH}${endM}`;
        }
        if (obj.countdown) {
            const n = new Date();
            const date1 = Date.UTC(startD.getFullYear(), startD.getMonth(), startD.getDate());
            const date2 = Date.UTC(n.getFullYear(), n.getMonth(), n.getDate());
            var ms = Math.abs(date1 - date2);
            obj.daysRemaining = Math.floor(ms / 1000 / 60 / 60 / 24);
            obj.isDayOfEvent = obj.daysRemaining == 0;
            obj.isReallyFarOff = obj.daysRemaining > 99;
            const dif = obj.daysRemaining.toString().split("");
            if (dif.length == 1) {
                obj.firstNum = 0;
                obj.secondNum = dif[0];
            } else {
                obj.firstNum = dif[0];
                obj.secondNum = dif[1];
            }
        }
        dest.push(obj);
    });
};
const $333f95d0b0b0f831$var$reconcileEvents = ()=>{
    if (!$333f95d0b0b0f831$var$pEventsLoaded || !$333f95d0b0b0f831$var$cEventsLoaded || !$333f95d0b0b0f831$var$hEventsLoaded) return;
    var all = $333f95d0b0b0f831$var$pEvents;
    all = all.concat($333f95d0b0b0f831$var$cEvents);
    all = all.concat($333f95d0b0b0f831$var$hEvents);
    all = [
        ...new Map(all.map((m)=>[
                m.title + m.date,
                m
            ])).values()
    ]; //get rid of dupes
    all.sort((a, b)=>{
        return a.trueDate - b.trueDate;
    }); //sort by date
    //ensure there is only 1 countdown event, and make it the second item in the list
    var hasCountDown = false;
    var countDownIndex = -1;
    for(var i = 0; i < all.length; i++)if (all[i].countdown && !hasCountDown) {
        countDownIndex = i;
        hasCountDown = true;
    } else all[i].countdown = false;
    if (countDownIndex > 1) {
        const obj = all.splice(countDownIndex, 1)[0];
        all.splice(1, 0, obj);
    }
    if (all.length > 15) all = all.slice(0, 15);
    if (all.length > 0) {
        const now = Date.now();
        localStorage.setObject(`${$333f95d0b0b0f831$var$STORAGE_ROOT}event_load`, now);
        localStorage.setObject(`${$333f95d0b0b0f831$var$STORAGE_ROOT}event_data`, all);
    }
    $333f95d0b0b0f831$var$renderEvents();
};
const $333f95d0b0b0f831$var$renderEvents = ()=>{
    gsap.to(document.getElementsByClassName("loader-container")[0], {
        opacity: 0,
        duration: 0.25
    });
    const events = localStorage.getObject(`${$333f95d0b0b0f831$var$STORAGE_ROOT}event_data`);
    const eventContainer = document.getElementById("events");
    gsap.to(eventContainer, {
        opacity: 1,
        duration: 0.5,
        delay: 0.25
    });
    eventContainer.innerHTML = "";
    if (!events || events.length == 0) //TODO: Empty state
    return;
    for(var i = 0; i < events.length; i++){
        const event = events[i];
        if (event.countdown == true) {
            const countdownContainer = document.createElement("section");
            const countdownDetails = document.createElement("div");
            const countdown3js = document.createElement("div");
            const countdownContentContainer = document.createElement("div");
            const countdownTitle = document.createElement("h2");
            const countdownMetadataContainer = document.createElement("div");
            const countdownMetadataTime = document.createElement("p");
            const countdownLocationContainer = document.createElement("div");
            const countdownLocationImage = document.createElement("img");
            const countdownLocation = document.createElement("p");
            const countdownImage = document.createElement("div");
            countdownContainer.classList.add("card", "countdown");
            countdownDetails.classList.add("card-details");
            countdown3js.classList.add("big-number");
            countdownContentContainer.classList.add("countdown-info");
            countdownMetadataContainer.classList.add("metadata");
            countdownLocationContainer.classList.add("wrap");
            countdownImage.classList.add("card-image");
            countdownTitle.innerHTML = event.isDayOfEvent ? event.title + " IS HERE!" : event.isReallyFarOff ? `${event.daysRemaining} DAYS UNTIL ` + event.title : "DAYS UNTIL " + event.title;
            countdownMetadataTime.innerHTML = event.date + event.time;
            countdownLocationContainer.style.display = event.location == "" ? "none" : "auto";
            countdownLocationImage.src = $333f95d0b0b0f831$var$icons.filter((i)=>i.keyword == "MapPinWhite")[0].image;
            countdownLocation.innerHTML = event.location;
            countdownImage.style.backgroundImage = "url(" + event.imageUrl + ")";
            eventContainer.append(countdownContainer);
            countdownContainer.append(countdownDetails, countdownImage);
            countdownDetails.append(countdown3js, countdownContentContainer);
            countdownContentContainer.append(countdownTitle, countdownMetadataContainer);
            countdownMetadataContainer.append(countdownMetadataTime, countdownLocationContainer);
            countdownLocationContainer.append(countdownLocationImage, countdownLocation);
            $333f95d0b0b0f831$var$setUpFx(countdown3js, event.firstNum, event.secondNum, event.isDayOfEvent, event.isReallyFarOff);
        } else {
            const cardContainer = document.createElement("div");
            const cardDetails = document.createElement("div");
            const cardCategoryContainer = document.createElement("div");
            const cardCategoryImg = document.createElement("img");
            const cardCategory = document.createElement("p");
            const cardContentContainer = document.createElement("div");
            const cardContentTitle = document.createElement("h2");
            const cardMetadataContainer = document.createElement("div");
            const cardMetadataTime = document.createElement("p");
            const cardLocationContainer = document.createElement("div");
            const cardLocationImage = document.createElement("img");
            const cardLocation = document.createElement("p");
            const cardImage = document.createElement("div");
            cardContainer.classList.add("card", "event");
            cardDetails.classList.add("card-details");
            cardCategoryContainer.classList.add("wrap");
            cardMetadataContainer.classList.add("metadata");
            cardLocationContainer.classList.add("wrap");
            cardImage.classList.add("card-image");
            const icon = $333f95d0b0b0f831$var$icons.filter((i)=>i.keyword == event.categoryIconKeyword);
            if (icon.length > 0) cardCategoryImg.src = icon[0].image;
            cardCategory.innerHTML = event.category;
            cardContentTitle.innerHTML = event.title;
            cardMetadataTime.innerHTML = event.date + event.time;
            cardLocationContainer.style.display = event.location == "" ? "none" : "auto";
            cardLocationImage.src = $333f95d0b0b0f831$var$icons.filter((i)=>i.keyword == "MapPin")[0].image;
            cardLocation.innerHTML = event.location;
            cardImage.style.backgroundImage = "url(" + event.imageUrl + ")";
            eventContainer.append(cardContainer);
            cardContainer.append(cardDetails, cardImage);
            cardDetails.append(cardCategoryContainer, cardContentContainer);
            cardCategoryContainer.append(cardCategoryImg, cardCategory);
            cardContentContainer.append(cardContentTitle, cardMetadataContainer);
            cardMetadataContainer.append(cardMetadataTime, cardLocationContainer);
            cardLocationContainer.append(cardLocationImage, cardLocation);
        }
    }
};
const $333f95d0b0b0f831$var$setUpFx = (parent, num1, num2, isDayOfEvent, isReallyFarOff)=>{
    const webgl = document.createElement("canvas");
    webgl.id = "webgl";
    webgl.classList.add("webgl-card");
    parent.append(webgl);
    if (isDayOfEvent) (0, $hrTe4.initializeFX)(webgl, null, null, false, "random", true, false);
    else if (isReallyFarOff) (0, $hrTe4.initializeFX)(webgl, null, null, false, "random", false, true);
    else (0, $hrTe4.initializeFX)(webgl, parseInt(num1), parseInt(num2), false, "random", false, false);
};
function $333f95d0b0b0f831$var$handleParseError(msg, err) {
    switch(err.code){
        case $4zpiX.Error.INVALID_SESSION_TOKEN:
            alert("Invalid session token.");
            $4zpiX.User.logOut();
            window.location = `${window.location.origin}/${window.location.pathname.includes("staging") ? "staging/" : ""}login.html?redirect=${window.location.pathname}`;
            break;
        default:
            console.log(`${msg} : ${err.code} - ${err.message}`);
    }
}
Storage.prototype.setObject = function(key, value) {
    this.setItem(key, JSON.stringify(value));
};
Storage.prototype.getObject = function(key) {
    var value = this.getItem(key);
    return value && JSON.parse(value);
};


//# sourceMappingURL=events.3a8f333e.js.map
